/*
*  File:            admin/slice.ts
*  Description:     Holds types and constants for Admin module
*  Author:          PreVeil
*/
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { action } from "typesafe-actions";
import { MessageItem, JSONOrgInfo, PaginationItem, DashboardUsage } from "@preveil-api";
import { AccountIdentifiers, InitialPaginationState, UsageSecuritySettings } from "src/common";
import keyMirror from "keymirror";

export interface AdminState {
  organization?: JSONOrgInfo; // THIS NEEDS TO BE CLEANED UP - right now dumping CS data here JSONOrgInfo
  logs: any[];
  errors?: MessageItem;
  pagination: PaginationItem;
  users_without_recovery?: number;
  selected: string[];
  actions_pending: boolean;
  users_with_export_shards: string[] | [];
  licenses?: number;
  dashboard_usage?: DashboardUsage;
  security_settings?: UsageSecuritySettings;
}
const initialState: AdminState = {
  logs: [],
  errors: undefined,
  pagination: InitialPaginationState,
  selected: [],
  actions_pending: false,
  users_with_export_shards: [],
  licenses: undefined,
  dashboard_usage: undefined,
  security_settings: undefined,
};

export const AdminActionTypes = keyMirror({
  GET_ORGANIZATION_INFO: null,
  DESTROY_ADMIN: null
});

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    getOrganizationInfoSuccess: (state, action: PayloadAction<JSONOrgInfo>) => {
      state.organization = action.payload;
    },
    destroyAdmin: () => {
      return initialState;
    },
    resetPagination: (state) => {
      state.pagination = initialState.pagination;
    },
    setPagination: (state, action: PayloadAction<PaginationItem>) => {
      state.pagination = action.payload;
    },
    setUsersWithoutRecovery: (state, action: PayloadAction<number>) => {
      state.users_without_recovery = action.payload;
    },
    setSelected: (state, action: PayloadAction<string[]>) => {
      state.selected = action.payload;
    },
    setUsersWithExportShards: (state, action: PayloadAction<string[]>) => {
      state.users_with_export_shards = action.payload;
    },
    setActionsPending: (state, action: PayloadAction<boolean>) => {
      state.actions_pending = action.payload;
    },
    setLicenses: (state, action: PayloadAction<number>) => {
      state.licenses = action.payload;
    },
    setDashboardUsage: (state, action: PayloadAction<DashboardUsage>) => {
      state.dashboard_usage = action.payload;
    },
    setSecuritySettings: (state, action: PayloadAction<UsageSecuritySettings>) => {
      state.security_settings = action.payload;
    },
  }
});

// ----------------------------------------------------------------------
// Saga specific Actions
// ----------------------------------------------------------------------
const getOrganizationInfo = (params: { account_ids: AccountIdentifiers, org_id: string }) => action(AdminActionTypes.GET_ORGANIZATION_INFO, params);
const adminSagaActions = {
  getOrganizationInfo
};

// ----------------------------------------------------------------------
// Global exports
// ----------------------------------------------------------------------
export const adminActions = { ...adminSlice.actions, ...adminSagaActions };
export default adminSlice.reducer;
